define('glu/grid/gridDefaultOptions',['require','./body/loadingView','./savedViews/components/savedViewsCollection','../locale'],function(require) {
    'use strict';

    var LoadingView = require('./body/loadingView'),
        SavedViewsCollection = require('./savedViews/components/savedViewsCollection'),
        locale = require('../locale');

    return {
        collection: null,
        columns: [],
        bulkActions: null,

        emptyViewText: null,
        loadingView: LoadingView,
        loadingViewText: null,
        caption: null,

        trackState: null,
        state: {},
        captureState: false,

        pageable: null,
        clientSidePagination: false,
        serverSidePagination: false,
        pagerLocation: null,
        paginate: false,
        pageSize: null,
        pageSizeValues: null,
        currentPage: null,
        paginateMethod: null,
        resultsName: locale.get('records'),

        resizeable: true,
        draggable: true,

        sortable: true,
        defaultSort: null,
        multiColumnSort: null,

        enableColumnRename: false,
        defaultColumnWidth: null,

        filterable: null,
        filter: null,
        filterMethod: null,
        badge: null,
        columnBadges: false,

        rowClassName: null,
        rowSubView: null,
        rowSubViewOptions: null,

        stickyFooter: true,
        bodyFirstView: null,
        groupBy: null,
        editOptions: null,
        disableAuxControl: false,
        disableDynamicColumnWidths: false,
        gridSearch: null, //true to include 'entire table' option in filter combo
        savedViews: {},
        savedViewsCollection: SavedViewsCollection
    };
});

